/* eslint-disable no-console */
import Vue from "vue";
import Vuex from "vuex";
import httpsBasic from "./utils/auth";
Vue.prototype.httpsBasic = httpsBasic;
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    token: "",
    roleList: [],
    map: "",
    layerCtrl: "",
    location: {
      longitude: 0,
      latitude: 0
    },
    // detail 页面显示的数据
    attrDetail: {}
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setRoleList(state, roleList) {
      state.roleList = roleList;
    },
    setToken(state, token) {
      state.token = token;
    },
    setGlobalMap(state, map) {
      state.map = map;
    },
    setGlobalLayerCtrl(state, layerCtrl) {
      state.layerCtrl = layerCtrl;
    },
    locationSync(state, payload) {
      state.location.longitude = payload.longitude;
      state.location.latitude = payload.latitude;
    },
    setAttrDetail(state, data) {
      state.attrDetail = data;
    }
  }
});
